export default __webpack_public_path__ + "static/media/sush.ffc096ec.jpeg";